import React, { Component } from 'react';
import RearrangeDataGrossMarginVolume from './RearrangeDataGrossMarginVolume'
import ReusableGraphGrossMarginVolume from './ReusableGraphGrossMarginVolume'
import RearrangeGraphISOTotal from './RearrangeGraphISOTotal'
import ReusableGraphISOTotal from './ReusableGraphISOTotal'
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { ColorRadioButton, ColorFormlabel } from '../../utils/materialUI_Reuseable_Comp'
import { LinearProgress } from '@material-ui/core';
import { ColorButtonAlignRight } from '../../utils/materialUI_Reuseable_Comp'
import { onClick_DownloadIamge, onClick_DownloadIamge_Second } from '../../utils/downloadGraphImage'
import DashboardKeyValuePairTable from '../../elements/ReactTableReUseAbleComponent/DashboardKeyValuePairTable.js';

const useStyles = makeStyles(styles);
class GrossMarginByIsoLineGraph extends Component {

    GrossMarginByIsoLineGraphUI = () => {
        var get_GraphQL_GrossMargin_Data = this.props.GraphQL_GrossMargin_Data_ISO
        var yearLists = this.props.yearList
        // console.log(get_GraphQL_GrossMargin_Data)
        const [graphViewState, setGraphViewState] = React.useState('0');
        const classes = useStyles();
        //variable to make key value pair for data due to the format of recharts graph
        var grossMarginLineGraphData_Series_KeyValuePair_all_iso_monthly, grossMargin_yearlytotal
        // reorganize the data in the formart graph can be drawn
        grossMarginLineGraphData_Series_KeyValuePair_all_iso_monthly = RearrangeDataGrossMarginVolume(get_GraphQL_GrossMargin_Data, yearLists)
        grossMargin_yearlytotal = RearrangeGraphISOTotal(get_GraphQL_GrossMargin_Data, yearLists)
        // console.log(grossMargin_yearlytotal)
        const handleViewGraphChnage = event => {
            setGraphViewState(event.target.value);
        };
        return (
            <>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={8}>
                        <Card elevation={3}>
                            <CardHeader color="success" icon>
                                <h4 className={classes.cardIconTitle}>Gross Margin of ISO's&nbsp;&nbsp;
                                <ColorButtonAlignRight variant="contained" color="primary" className={classes.margin}
                                        onClick={onClick_DownloadIamge}>
                                        Download Graph</ColorButtonAlignRight></h4>
                            </CardHeader>
                            <CardBody>
                                <div id="my-node">
                                    <ReusableGraphISOTotal
                                        data_to_drawGraph_total={grossMargin_yearlytotal}
                                        data_to_drawGraph_Monthly={get_GraphQL_GrossMargin_Data}
                                        View_Dollar_Graph={true}
                                        yearList={this.props.yearList}
                                    />
                                </div>
                            </CardBody>
                        </Card>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={4}>
                        <Card chart className={classes.cardHover}>
                            <CardBody>
                                <h4 className={classes.cardTitle}>Total Gross Margin Table</h4>

                            </CardBody>
                            <CardHeader>
                                {grossMargin_yearlytotal[0] !== undefined ?
                                    <DashboardKeyValuePairTable
                                        table_data={grossMargin_yearlytotal}
                                        condition={true}
                                    /> : <LinearProgress />}
                            </CardHeader>
                        </Card>
                    </GridItem>
                    <GridItem xs={12}>
                        <Card elevation={3}>
                            <CardHeader color="success" icon>
                                <h4 className={classes.cardIconTitle}>View Data by Monthly of Gross Margin of Each ISO</h4>
                            </CardHeader>
                            <CardBody>
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <ColorFormlabel component="legend">Please Select the View</ColorFormlabel>
                                    <RadioGroup aria-label="gender"
                                        name="gender1"
                                        value={graphViewState}
                                        onChange={handleViewGraphChnage}
                                        style={{ display: 'inline', flexDirection: 'row' }}>
                                        <FormControlLabel value="0" control={<ColorRadioButton />} label="Line Graph" />
                                        <FormControlLabel value="1" control={<ColorRadioButton />} label="Transparent Area Fill View" />
                                        <FormControlLabel value="2" control={<ColorRadioButton />} label="Stacked Bar Graph View" />
                                    </RadioGroup>
                                </FormControl>
                                <ColorButtonAlignRight variant="contained" color="primary" className={classes.margin}
                                    onClick={onClick_DownloadIamge_Second}>
                                    Download Graph</ColorButtonAlignRight>&nbsp;&nbsp;
                {grossMarginLineGraphData_Series_KeyValuePair_all_iso_monthly[0] !== null ?
                                    <>
                                        <div id="my-node2">
                                            <ReusableGraphGrossMarginVolume
                                                data_to_drawGraph={grossMarginLineGraphData_Series_KeyValuePair_all_iso_monthly}
                                                graphViewSelection={graphViewState}
                                                View_Dollar_Graph={true}
                                            /> </div></>
                                    : <LinearProgress />}
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </>
        )
    }
    render() {
        return (<this.GrossMarginByIsoLineGraphUI />)
    }
}
export default GrossMarginByIsoLineGraph;